import { Reveal, Eyebrow } from "../Reveal";
import { ArrowUpRight } from "lucide-react";

const profiles = [
  {
    name: "Stay-at-home moms",
    image: "https://images.unsplash.com/photo-1588346986082-dbadd9babce0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxtb3RoZXIlMjB3b3JraW5nJTIwaG9tZSUyMGxhcHRvcCUyMGNoaWxkJTIwaGFwcHl8ZW58MHx8fHwxNzkxODQ0OTAxfDA&ixlib=rb-4.1.0&q=85",
    challenge: "Years out of the workforce, a CV gap software punishes, and a day with no spare hour.",
    help: "Learn AI in 20-minute lessons between naps and school runs — and use it to return to work on your terms.",
  },
  {
    name: "Grandmothers",
    image: "https://images.unsplash.com/photo-1601509874592-18ae5b627f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzN8MHwxfHNlYXJjaHwxfHxncmFuZG1vdGhlciUyMHNtaWxpbmclMjBob2xkaW5nJTIwbGFwdG9wJTIwaG9tZXxlbnwwfHx8fDE3OTE4NDQ5MDF8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Targeted by AI voice scams and fake messages, and too often talked down to about technology.",
    help: "Patient, respectful training that turns you into the family's first line of defence against AI scams.",
  },
  {
    name: "Every mom",
    image: "https://images.unsplash.com/photo-1614287350843-7b7c228df8cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxtb3RoZXIlMjB3b3JraW5nJTIwaG9tZSUyMGxhcHRvcCUyMGNoaWxkJTIwaGFwcHl8ZW58MHx8fHwxNzkxODQ0OTAxfDA&ixlib=rb-4.1.0&q=85",
    challenge: "Raising kids while running a household — whatever your situation, there never seems to be a spare hour.",
    help: "AI tools that lighten your day-to-day load, protect your family, and open flexible income paths — all free to learn.",
  },
];

export const WhoWeHelp = () => (
  <section id="who" className="py-20 md:py-28 bg-cream-2 border-y border-linen" data-testid="who-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mb-16">
        <Reveal><Eyebrow>02 · Who we help</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-serif font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12]" data-testid="who-heading">
            Built for the women the tech world forgot.
          </h2>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {profiles.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.12} className={i === 1 ? "md:mt-12" : ""}>
            <div className="group bg-white rounded-2xl border border-linen overflow-hidden transition-shadow duration-300 hover:shadow-xl hover:shadow-stone-900/10"
                 data-testid={`who-card-${i}`}>
              <div className="overflow-hidden h-56">
                <img src={p.image} alt={p.name} loading="lazy"
                     className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl font-semibold text-ink">{p.name}</h3>
                <p className="mt-3 text-sm text-stone-500 leading-relaxed">{p.challenge}</p>
                <div className="mt-5 pt-5 border-t border-linen">
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ember mb-2">How we help</p>
                  <p className="text-sm text-stone-700 leading-relaxed">{p.help}</p>
                </div>
                <a href="/#join" data-testid={`who-workshop-link-${i}`}
                   className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-ember hover:text-ember-dark transition-colors duration-300">
                  Join the community — free <ArrowUpRight size={15} />
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
